<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="10">
                <button class="btn btn-primary" :class="filterFilter===CONSTANTS.TASK_FILTER_AUTHOR?'btn-warning':'btn-primary'" @click="setFilterFilter(CONSTANTS.TASK_FILTER_AUTHOR)">
                    Я автор
                </button> &nbsp;

                <button class="btn btn-primary" :class="filterFilter===CONSTANTS.TASK_FILTER_ASSIGNEE?'btn-warning':'btn-primary'" @click="setFilterFilter(CONSTANTS.TASK_FILTER_ASSIGNEE)">
                    Я исполнитель
                </button> &nbsp;

                <button class="btn btn-primary" :class="filterFilter===CONSTANTS.TASK_FILTER_GROUP?'btn-warning':'btn-primary'" @click="setFilterFilter(CONSTANTS.TASK_FILTER_GROUP)">
                    Групповые задачи
                </button> &nbsp;

                <button class="btn btn-primary" :class="filterFilter===CONSTANTS.TASK_FILTER_COMPANY?'btn-warning':'btn-primary'" @click="setFilterFilter(CONSTANTS.TASK_FILTER_COMPANY)">
                    Все задачи компании
                </button> &nbsp;

                <button class="btn btn-primary" :class="filterFilter===CONSTANTS.TASK_FILTER_ARCHIVE?'btn-warning':'btn-primary'" @click="setFilterFilter(CONSTANTS.TASK_FILTER_ARCHIVE)">
                    Архив
                </button> &nbsp;

            </b-col>
            <b-col align="right" md="2">
                <button class="btn btn-success" @click="onCreateTask"><i class="fa fa-plus"></i> &nbsp; Добавить задачу</button>
                <br><br>
            </b-col>
        </b-row>

        <div class="row">
            <div class="col col-12 col-md-6">
                <b-form-group>
                    <v-select
                        v-model="statusFilter"
                        :options="tasktypes"
                        label="title"
                        :reduce="x=>x.id"
                    >
                    </v-select>
                </b-form-group>
            </div>
        </div>
        <v-server-table :url="tableurl" :columns="columns"  :options="options" :theme="theme" id="tasksTable" ref="tasksTable">
            <span slot="id" slot-scope="props">
                <a :href="'#/task/'+props.row.id">{{props.row.id}}</a><br>
                <span>{{CONSTANTS.TASK_STATUS_NAMES[props.row.status]}} </span>
            </span>
        </v-server-table>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_tasks } from '@/functions_tasks.js';
    import {CONSTANTS} from '@/constants';
    import subject from '../jsx/tasks/subject'
    import user_id from '../jsx/tasks/user_id'
    import assignee_id from '../jsx/tasks/assignee_id'
    import created_at from '../jsx/tasks/created_at'
    import wakeup_at from '../jsx/tasks/wakeup_at'
    import deadline_at from '../jsx/tasks/deadline_at'

    Vue.use(ServerTable);

    export default {
        name: 'NsbPanelTasks',
        components: {
            ServerTable,
            Event,
        },
        mixins: [functions, functions_tasks],
        data: function () {
            return {
                columns: ['id', 'subject', 'user_id', 'assignee_id', 'created_at', 'wakeup_at', 'deadline_at' ],
                saveState: true,
                options: {
                    headings: {
                        id: '#',
                        created_at: 'создано в',
                        wakeup_at:  'начать в',
                        deadline_at: 'крайний срок',
                        user_id: 'автор',
                        status: 'статус',
                        subject: 'заголовок',
                        assignee_id: 'исполнитель',
                    },
                    sortable: ['id', 'created_at'],
                    filterable: ['id', 'user_id', 'assignee_id', 'subject', ],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    templates: {
                        subject,
                        user_id,
                        assignee_id,
                        created_at,
                        deadline_at,
                        wakeup_at
                    },
                    customFilters: [
                        'filter',
                        'status'
                    ],
                    initFilters: {
                        filter:this.$store.state.taskFilters.filterFilter,
                        status:this.$store.state.taskFilters.statusFilter,
                    },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    saveState: true,
                    rowClassCallback: this.latestTaskClass,
                },
                theme: 'bootstrap4',
                filterFilter:null,
                statusFilter:null,
                filtersLoaded:false,
            }
        },
        methods: {
            onCreateTask: function () {
                this.createTask();
            },

            setFilterFilter: function(filter) {
                this.filterFilter = filter;
                this.saveFilter();
                Event.$emit('vue-tables.filter::filter', this.filterFilter);
            },

            saveFilter() {
                this.$store.commit('saveTaskFilters', {
                    filterFilter:this.filterFilter,
                    statusFilter:this.statusFilter,
                });
            },

            restoreFilter() {
                this.filterFilter = this.$store.state.taskFilters.filterFilter;
                if (!this.filterFilter) this.filterFilter=null;

                this.statusFilter = this.$store.state.taskFilters.statusFilter;
                if (!this.statusFilter) this.statusFilter=null;
            }

        },

        computed: {
            tableurl: function () {
                return this.apiurl('task/table-fu');
            },
        },

        created: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.loadTaskTypes();
            this.restoreFilter();
        },

        notifications: {
            showMessageTaskCreated:
                {
                    type: 'success',
                    title: 'Задача создана',
                    message: 'Задача была успешно создана, теперь вы можете перейти к ее редактированию'
                },
        },
    }
</script>
